import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\NaturalPersonController::store
* @see app/Http/Controllers/NaturalPersonController.php:26
* @route '//app.finesthub.de/natural-persons'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/natural-persons',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\NaturalPersonController::store
* @see app/Http/Controllers/NaturalPersonController.php:26
* @route '//app.finesthub.de/natural-persons'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NaturalPersonController::store
* @see app/Http/Controllers/NaturalPersonController.php:26
* @route '//app.finesthub.de/natural-persons'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NaturalPersonController::update
* @see app/Http/Controllers/NaturalPersonController.php:75
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
export const update = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/natural-persons/{natural_person}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\NaturalPersonController::update
* @see app/Http/Controllers/NaturalPersonController.php:75
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
update.url = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { natural_person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { natural_person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            natural_person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        natural_person: typeof args.natural_person === 'object'
        ? args.natural_person.id
        : args.natural_person,
    }

    return update.definition.url
            .replace('{natural_person}', parsedArgs.natural_person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\NaturalPersonController::update
* @see app/Http/Controllers/NaturalPersonController.php:75
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
update.put = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\NaturalPersonController::update
* @see app/Http/Controllers/NaturalPersonController.php:75
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
update.patch = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\NaturalPersonController::destroy
* @see app/Http/Controllers/NaturalPersonController.php:141
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
export const destroy = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/natural-persons/{natural_person}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\NaturalPersonController::destroy
* @see app/Http/Controllers/NaturalPersonController.php:141
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
destroy.url = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { natural_person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { natural_person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            natural_person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        natural_person: typeof args.natural_person === 'object'
        ? args.natural_person.id
        : args.natural_person,
    }

    return destroy.definition.url
            .replace('{natural_person}', parsedArgs.natural_person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\NaturalPersonController::destroy
* @see app/Http/Controllers/NaturalPersonController.php:141
* @route '//app.finesthub.de/natural-persons/{natural_person}'
*/
destroy.delete = (args: { natural_person: string | number | { id: string | number } } | [natural_person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const NaturalPersonController = { store, update, destroy }

export default NaturalPersonController